<template>
    <bottom-sheet
            title="代付金額"
            @onCancel="onCancel"
            @onConfirm="onConfirm"
            @onClose="onClose">
        <div class="expected-main">
            <div class="input">
                <div>
                    <div class="product">
                        $ {{ cartProductPrice }}
                    </div>
                    <div class="tip">
                        購物車
                    </div>
                </div>
                <div class="plus">
                    <img src="@/assets/img/add.svg">
                </div>
                <div>
                    <div class="expected">
                        <input v-if="!price" type="number" placeholder="商品大概多少錢" min="0" @input="setPrice">
                        <input v-else type="number" min="0" v-model="price">
                    </div>
                    <div class="tip">
                        自訂商品
                    </div>
                </div>
            </div>
            <div class="sum">
                總代付金額 <span>$ {{ sumPrice }}</span>
            </div>
        </div>
    </bottom-sheet>
</template>

<script>
    import BottomSheet from '../BottomSheet';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'SetExpectedPrice',
        components: {
            'bottom-sheet': BottomSheet,
        },
        data() {
            return {
                errMsg: '',
                price: '',
            }
        },
        computed: {
            sumPrice() {
                return this.cartProductPrice + parseInt(this.price || '0');
            },
            ...mapGetters(['cart', 'cartProductPrice'])
        },
        methods: {
            setPrice(e) {
                this.price = parseInt(e.target.value);
            },
            onCancel() {
                this.$emit('onCancel');
            },
            onConfirm() {
                this.setCartData({
                    value: Math.max(parseInt(this.price || '0'), 0),
                    key: 'expected_price'
                });
                this.$emit('onDone');
            },
            onClose() {
                this.$emit('onCancel');
            },
            ...mapActions(['setCartData'])
        },
        mounted() {
            this.price = parseInt(this.cart.expected_price);
        }
    };
</script>

<style lang="scss" scoped>
    .expected-main {
        padding: 15px;

        .input {
            display: flex;
            justify-content: space-around;
            align-items: flex-start;
            margin-top: 20px;

            .product {
                color: #4A4A4A;
                font-size: 18px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 25px;
                text-align: center;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .plus {
                img {
                    height: 40px;
                }
            }

            .expected {
                input {
                    color: #9B9B9B;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    text-align: center;
                    height: 40px;
                    width: 182px;
                    box-sizing: border-box;
                    border: 1px solid #DDDDDD;
                    border-radius: 4px;
                    background-color: #FFFFFF;
                }
            }

            .tip {
                color: #9B9B9B;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                text-align: center;
            }
        }

        .sum {
            margin-top: 35px;
            color: #339933;
            font-size: 16px;
            letter-spacing: 0;
            line-height: 22px;
            text-align: center;

            span {
                font-weight: 500;
            }
        }
    }
</style>
